import React, { useEffect, useState } from "react";
import "./DeliveryScheduleDetailPopup.scss";
import { useDispatch } from "react-redux";
import ApiService from "../../services/apiService";
import URL from "../../urls/Urls";
import { ToastContainer, toast } from "react-toastify";
import { toastOptions } from "../../utils/toast";
import { FilterOptionSchema } from "../Filter/filter.data";
import Filter from "../Filter/Filter";
import { DeliveryScheduleRecord } from "../../models/DeliveryCalendar";

interface DeliveryScheduleDetailPopupProps {
  schedule: DeliveryScheduleRecord;
  handleClose: () => void;
}

const DeliveryScheduleDetailPopup: React.FC<
  DeliveryScheduleDetailPopupProps
> = ({ schedule, handleClose }) => {
  const handleTrackLinkOpen = (track_link: string) => {
    if (track_link && track_link.startsWith("http")) {
      window.open(track_link, "_blank");
    }
  };
  return (
    <div className="delivery-schedule-detail-popup-dialog-main-container flex-column gap-12 xetgo-font-tag-bold">
      <div className="upper-bar-container px-16 py-12 flex-row align-items-center justify-content-space-between">
        <h3 className="xetgo-font-tag bolder m-0"> Delivery Details</h3>
        <img
          onClick={handleClose}
          className="cursor-pointer"
          height={8}
          width={8}
          src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240624162818-close+2.svg"
          alt="close-icon"
        />
      </div>
      <div className="delivery-schedule-middle-main-container px-16 flex-column gap-12 p-12">
        <div className="flex-row align-items-center justify-content-space-between delivery-schedule-popup-gap xetgo-font-tag">
          <p>PO No.</p>
          <p className="sub-title flex-1 flex-row align-items-center justify-content-flex-end">
            {schedule.po_number}
          </p>
        </div>
        <div className="flex-row align-items-center justify-content-space-between delivery-schedule-popup-gap xetgo-font-tag">
          <p>SKU</p>
          <p className="sub-title flex-1 flex-row align-items-center justify-content-flex-end">
            {schedule.product_name || "--"}
          </p>
        </div>
        <div className="flex-row align-items-center justify-content-space-between delivery-schedule-popup-gap xetgo-font-tag">
          <p>Vendor Name</p>
          <p className="sub-title flex-1 flex-row align-items-center justify-content-flex-end">
            {schedule.vendor_company_name || "--"}
          </p>
        </div>

        <div className="flex-row align-items-center justify-content-space-between delivery-schedule-popup-gap xetgo-font-tag">
          <p>Quantity</p>
          <p className="sub-title flex-1 flex-row align-items-center justify-content-flex-end">
            {schedule.delivered_quantity || "--"} {schedule.unit}
          </p>
        </div>
        <div className="flex-row align-items-center justify-content-space-between delivery-schedule-popup-gap xetgo-font-tag">
          <p>Location</p>
          <p className="sub-title flex-1 flex-row align-items-center justify-content-flex-end">
            {schedule.address_line}
            {schedule.city || "--"}
          </p>
        </div>
        <div className="flex-row align-items-center justify-content-space-between delivery-schedule-popup-gap xetgo-font-tag">
          <p>Expected Date</p>
          <p className="sub-title flex-1 flex-row align-items-center justify-content-flex-end">
            {schedule.expected_delivery_date || "--"}
          </p>
        </div>
        <div className="flex-row align-items-center justify-content-space-between delivery-schedule-popup-gap xetgo-font-tag">
          <p>Dispatched Date</p>
          <p className="sub-title flex-1 flex-row align-items-center justify-content-flex-end">
            {schedule.dispatch_date || "--"}
          </p>
        </div>
        <div className="flex-row align-items-center justify-content-space-between delivery-schedule-popup-gap xetgo-font-tag">
          <p>Delivered Date</p>
          <p className="sub-title flex-1 flex-row align-items-center justify-content-flex-end">
            {schedule.actual_delivery_date || "--"}
          </p>
        </div>

        <div className="flex-row align-items-center justify-content-space-between delivery-schedule-popup-gap xetgo-font-tag">
          <p>Tracking Detail</p>

          <p
            onClick={() => handleTrackLinkOpen(schedule.track_link || "")}
            className="track-link sub-title flex-1 flex-row align-items-center justify-content-flex-end"
          >
            {schedule.track_link || "--"}
          </p>
        </div>
      </div>
      <div className="delivery-schedule-detail-popup-btns-containers p-12 gap-12 flex-row align-items-center justify-content-space-between">
        {schedule.invoice && (
          <a
            target="_blank"
            href={schedule.invoice || ""}
            rel="noopener noreferrer"
            className="pod-btn xetgo-font-tag bold flex-row gap-12 align-items-center justify-content-center flex-1 py-8"
          >
            <p className="xetgo-font-tag bold">Invoice</p>
            <img
              src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240510114359-arrow-right+%282%29.svg"
              alt="uploaded"
              width={12}
              height={12}
            />
          </a>
        )}
        {schedule.pod && (
          <a
            target="_blank"
            href={schedule.pod || ""}
            rel="noopener noreferrer"
            className="pod-btn xetgo-font-tag bold flex-row gap-12 align-items-center justify-content-center flex-1 py-8"
          >
            <p className="xetgo-font-tag bold">POD</p>
            <img
              src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240510114359-arrow-right+%282%29.svg"
              alt="uploaded"
              width={12}
              height={12}
            />
          </a>
        )}
      </div>
    </div>
  );
};

export default DeliveryScheduleDetailPopup;
